<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img src="/logo.png" class="c-sidebar-brand-full" name="logo" height="32px"/>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="menuNav">
      <CSidebarNavLabel name="name">
      </CSidebarNavLabel>
    </CRenderFunction>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',
  props: {
    menuNav: {
      type: Array
    },
    initMenu: {
      type: Function
    }
  },
  mounted() {
    this.initMenu()
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>
